import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TorichatHistoryChat from "./historyChat";
import BasicTabs from "components/BasicTabs";
import { ALL_PERMISSION } from "constants/permission";
import TorichatProfessionalKnowledge from "./professionalKnowledge";
import TorichatSetting from "./setting";
import AIAssistantService from "services/aiAssistantService";
import { Modal, Spin } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import GeneralInfoPage from "./GeneralInfoPage";

export default function Torichat() {
  const { t: translation } = useTranslation();
  const [merchantCode, setMerchantCode] = useState(null);
  const [partyActiveStatus, setPartyActiveStatus] = useState(null);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const getConfigTorichat = () => {
    setLoading(true);
    AIAssistantService.Update({}).then((res) => {
      if (!res?.data?.[0]) {
        history.goBack();
      }
      setLoading(false);
      const partyRequiredData = res?.data?.[0]?.partyRequiredData;
      partyRequiredData &&
        setMerchantCode((JSON.parse(partyRequiredData) || {})?.merchantCode);
      setPartyActiveStatus(res?.data?.[0]?.partyActiveStatus);
    });
  };

  useEffect(() => {
    getConfigTorichat();
  }, []);

  const listTab = [
    {
      key: "list",
      label: translation("torichat.historyChat"),
      permission: undefined,
      component: <TorichatHistoryChat merchantCode={merchantCode} />,
    },
    {
      key: "setting",
      label: translation("torichat.settingVirtualAssistant"),
      permission: undefined,
      component: <TorichatSetting merchantCode={merchantCode} />,
    },
    {
      key: "professionalKnowledge",
      label: translation("torichat.professionalKnowledge"),
      permission: undefined,
      component: <TorichatProfessionalKnowledge merchantCode={merchantCode} />,
    },
    {
      key: "generalInfo",
      label: translation("torichat.generalInfo"),
      permission: undefined,
      component: <GeneralInfoPage merchantCode={merchantCode} />,
    },
  ];
  if (loading) {
    return (
      <div className="flex-center loading">
        <Spin />
      </div>
    );
  }
  return (
    <div>
      {partyActiveStatus === 1 ? (
        <BasicTabs
          tabs={listTab}
          permissionConstant={ALL_PERMISSION.MANAGE_TORICHAT.permissionTab}
        />
      ) : (
        <Modal
          title={translation("Notification")}
          centered
          open={partyActiveStatus !== 1}
          onOk={() => {
            history.push("/setting?permission=camera&tab=SETTING_EXPAND");
          }}
          onCancel={() => history.goBack()}
          okText={"Thiết lập"}
          cancelText={translation("cancel")}
        >
          Chưa kết nối trợ lý ảo AI Torichat!
        </Modal>
      )}
    </div>
  );
}
